<template>
<div class="row nav-header sticky-top">
    <div class="container bg__responsive">
        <nav class="navbar navbar-expand-lg navbar-light js-main-nav">
            <!-- Brand Logo -->
            <a class="navbar-brand" href="/">
                <img src="@/assets/images/ah-iso.svg" alt="Ginny App Logo">
            </a>

            <!-- Button Register table -->
            <div class="feature-navbar-mobile">
                <form class="form-inline my-2 my-lg-0 d-none d-sm-block d-md-block d-lg-none" :class="{'d-block': hideNavbar}">
                    <button
                        @click="showModal"
                        class="btn btn-orange my-2 my-sm-"
                        type="button">
                        ¡Registrarme!
                        <i class="fas fa-paper-plane"></i>
                    </button>
                </form>

                <!-- NavBar Mobile -->
                <button
                    @click="toogleNavbar"
                    v-if="!hideNavbar"
                    class="navbar-toggler"
                    type="button"
                    :aria-expanded="isOpen"
                    aria-label="Toggle navigation">
                    <i class="fas fa-bars"></i>
                </button>
            </div>

            <!-- NavBar Desktop -->
            <transition :name="isMobile ? 'navbar-transition' : ''">
                <div
                    v-if="isOpen"
                    class="feature-navbar-desktop navbar-collapse justify-content-end"
                    id="navbarSupportedContent"
                >
                    <ul class="navbar-nav" v-if="!hideNavbar">
                        <li class="nav-item" @click="onItemClick">
                            <a class="nav-link" href="/#video-about">¿Qué es ginny? <span class="sr-only">(current)</span></a>
                        </li>
                        <li class="nav-item" @click="onItemClick">
                            <a class="nav-link" href="/#fuctionality">Vincular Tarjeta</a>
                        </li>
                        <li class="nav-item" @click="onItemClick">
                            <a class="nav-link" href="/#available">Disponible en</a>
                        </li>
                        <!-- <li class="nav-item" @click="onItemClick">
                            <a class="nav-link" target="_blank" href="https://intercom.help/ginny/es/">Ayuda</a>
                        </li> -->
                    </ul>
                    <!-- Button Register -->
                    <form class="form-inline my-2 my-lg-0">
                        <button
                            @click="onItemClick(); showModal();"
                            class="btn btn-orange my-2 my-sm-  d-block d-sm-none d-sm-block d-md-none d-lg-block d-xl-block"
                            type="button">
                            ¡Registrarme! <i class="fas fa-paper-plane"></i>
                        </button>
                    </form>
                </div>
            </transition>
        </nav>
    </div>
    <sign-up-modal />
</div>
</template>

<script>
import { getParents } from "@/utils";

export default {
    props: {
        hideNavbar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            width: window.document.body.offsetWidth
        }
    },
    computed: {
        isMobile() {
            return this.width < 992;
        }
    },
    mounted() {
        this.updateWidth();
        window.addEventListener("resize", this.updateWidth);
    },
    methods: {
        toogleNavbar() {
            this.isOpen = !this.isOpen;
        },
        showModal() {
            this.$modal.show('sign-up-modal');
        },
        updateWidth() {
            this.width = window.document.body.offsetWidth;

            if (this.isMobile) {
                document.addEventListener('click', this.onDocumentClick);
            } else {
                this.isOpen = true;
                document.removeEventListener('click', this.onDocumentClick);
            }
        },
        onDocumentClick(e) {
            const isNavbar = Boolean(e.target.classList.contains('js-main-nav'));
            const isInNavbar = Boolean(getParents(e.target, '.js-main-nav').length);

            if (!(isNavbar || isInNavbar) && this.isOpen) {
                this.isOpen = false;
            }
        },
        onItemClick() {
            if (this.isMobile) {
                this.isOpen = false;
            }
        }
    }
}
</script>


<style scoped lang="scss">
.nav-header {
    background-color: #1F9B90;
    padding: 0;
    height: 90px;
    font-family: $secondary-font;

    nav {
        height: 100%;
        min-height: 90px;

        a {
            color:white!important;
            font-size: smaller;
            font-weight: 700;
        }

        .feature-navbar-mobile {
            display: flex;
        }
    }
}

.bg__responsive {
    max-width: 1300px;
}

.btn-orange{
    padding: 0.50rem 1rem!important;
    border-radius: 1.25rem;

    &:hover {
        background-color:$white-color;
        border-color: $white-color;
        box-shadow: 0 0 0 0.2rem #00B09B5c!important;
        color: #00B09B;
    }

    &:active {
        background-color:$white-color!important;
        border-color: $white-color!important;
        color: #00B09B;
    }
}
.nav-item {
    .nav-link {
        border-bottom: 2px solid #1F9B90;
        border-radius: 3%;
        &:hover,
        &:active {
            border-bottom-color: #fff;
        }
    }

    &.active {
        .nav-link {
            border-bottom: 2px solid #fff;
            border-radius: 3%;

            &:hover,
            &:active {
                border-bottom-color: #fff;
            }
        }
    }
}
// Medium devices (tablets, 991px)
@media screen and (max-width:991px) {
    .bg__responsive {
        padding: 0;
        background-color: #1F9B90;
    }
    .nav-header {

        .container {
            max-width: 100%;
        }
    }

    nav {
        padding:1.5rem 1rem 1rem;

        .navbar-brand {
            margin-left:1rem;
        }

        .navbar-toggler {
            background-color: transparent;
            border: transparent;
            outline: none;

            i {
                color: #fff;
                font-size: 25px;
                margin-right: 0.75rem;
            }
        }
    }

    .navbar-collapse {
        background-color: #1F9B90;
        .nav-item {
            border-bottom: 1px solid #f8f9faba
        }
        .navbar-nav {
            padding: 30px 20px 0 20px;
        }
        .form-inline {
            padding: 0 20px;
        }
    }


    .nav-item {
        .nav-link {
            &:hover,
            &:active {
                border-bottom-color: transparent;
                background: #acdee22e;
            }
        }
    }
}

@media screen and (max-width:375px) {
    .navbar-brand {
        margin: .4rem;
    }
    .feature-navbar-mobile {
        .btn-orange {
           font-size: $mobile-extra-small-font-size;
        }
    }
}

.navbar-transition {
    &-enter,
    &-leave-to {
        max-height: 0;
        opacity: 0;
        transition: max-height 0.3s ease-out, opacity 0.35s ease-out;
    }

    &-enter-to,
    &-leave {
        opacity: 1;
        max-height: 100vh;
        transition: max-height 0.5s ease-in, opacity 0.55s ease-in;
    }
}
</style>